import { EXPORT_DOCUMENT_TITLE_KEYS } from './exportExcelNaming';
import { uiT } from './uiTranslate';

/** Visible leading order for qlty026/032: checkbox → edit icon → ID. */
export const OTK_COMPANY_LEADING_COLUMN_FIELDS = Object.freeze(['rowSelection', 'editor', 'id']);

/**
 * Saved user/standard masks may still store checkbox → ID → editor.
 * Reorder only those three fields when present; leave remaining columns intact.
 */
export function pinOtkCompanyLeadingColumns(attributes) {
  if (!Array.isArray(attributes) || attributes.length === 0) return attributes;
  const leadingSet = new Set(OTK_COMPANY_LEADING_COLUMN_FIELDS);
  const byField = new Map();
  const rest = [];
  for (const node of attributes) {
    const field = node && typeof node === 'object' ? node.field : null;
    if (typeof field === 'string' && leadingSet.has(field) && !byField.has(field)) {
      byField.set(field, node);
    } else {
      rest.push(node);
    }
  }
  const leading = OTK_COMPANY_LEADING_COLUMN_FIELDS
    .map((field) => byField.get(field))
    .filter(Boolean);
  if (leading.length === 0) return attributes;
  return [...leading, ...rest];
}

export const OTK_COMPANY_LIST_MASKS = Object.freeze({
  certificates: Object.freeze({
    pageListKey: 'OtkCompanyCertificateList',
    detailPage: 'OtkCompanyCertificateAdd',
    detailMask: 'qlty027',
    editTabKey: 'OtkCompanyList.Tab.PartnerCard',
    get addTabName() { return uiT('OtkCompanyList.Tab.PartnerCard'); },
    get editTabName() { return uiT('OtkCompanyList.Tab.PartnerCard'); },
    get favoriteTitle() { return uiT('OtkCompanyList.Favorite.PartnerDocsList'); },
    notificationPage: 'OtkCompanyCertificateList',
    exportTitleKey: EXPORT_DOCUMENT_TITLE_KEYS.BUSINESS_PARTNERS,
  }),
  cards: Object.freeze({
    pageListKey: 'OtkCompanyCardList',
    detailPage: 'OtkCompanyCardDetail',
    detailMask: 'qlty033',
    editTabKey: 'OtkCompanyList.Tab.PartnerDocs',
    get addTabName() { return uiT('OtkCompanyList.Tab.PartnerDocs'); },
    get editTabName() { return uiT('OtkCompanyList.Tab.PartnerDocs'); },
    get favoriteTitle() { return uiT('OtkCompanyList.Tab.PartnerDocs'); },
    notificationPage: 'OtkCompanyCardList',
    exportTitleKey: EXPORT_DOCUMENT_TITLE_KEYS.BUSINESS_PARTNERS,
  }),
});
